import type { ProductInventoryItemDto } from '../dto';
import type { ProductInventoryOption } from '../model';
import type { IProductInventoryOptionMapper } from './IProductInventoryOptionMapper';

export class ProductInventoryOptionMapper implements IProductInventoryOptionMapper {
    toOption(product: ProductInventoryItemDto): ProductInventoryOption | null {
        const value = this.resolveValue(product);

        if (!value) {
            return null;
        }

        return {
            value,
            label: this.resolveLabel(product, value),
            vatRate: this.resolveVatRate(product),
            raw: product,
        };
    }

    private resolveValue(product: ProductInventoryItemDto): string {
        const value =
            product.id ??
            product.productId ??
            product.product_id ??
            product.externalId ??
            product.external_id ??
            product.ean ??
            product.sku ??
            product.code ??
            '';

        return String(value);
    }

    private resolveLabel(
        product: ProductInventoryItemDto,
        fallback: string,
    ): string {
        return (
            product.name ??
            product.productName ??
            product.product_name ??
            product.displayName ??
            product.display_name ??
            fallback
        );
    }

    private resolveVatRate(
        product: ProductInventoryItemDto,
    ): number | string | undefined {
        return product.vatRate ?? product.vat_rate;
    }
}